import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router";
import axios from "axios";

import { ModernContainer } from "./styled/modernTheme";

import Banner from "./themes/modern/banner";
import Introduce from "./themes/modern/introduce";
import Products from "./themes/modern/products";
import Portfolio from "./themes/modern/portfolio";

const ModernTheme = ({ homepageInfo }) => {
  const navigate = useNavigate();
  const { cmpnyNo, url } = useOutletContext();
  const [products, setProducts] = useState([]);
  const [menuGroups, setMenuGroups] = useState([]);

  useEffect(() => {
    if (cmpnyNo) {
      getProducts(cmpnyNo);
      getMenuGroup(cmpnyNo);
    }
  }, [cmpnyNo]);

  const fillWithRepeat = (source, count, excludeSet = null) => {
    const result = [];
    const sourceList = excludeSet ? source.filter((p) => !excludeSet.has(p.id)) : [...source];

    if (sourceList.length === 0) return result;

    let i = 0;
    while (result.length < count) {
      const item = sourceList[i % sourceList.length];
      result.push(item);
      if (excludeSet) excludeSet.add(item.id);
      i++;
      if (i > 1000) break;
    }

    return result;
  };

  const getProducts = async (cmpnyNo) => {
    try {
      const url = "/erp/vendorProducts/get";
      const query = `
        query VendorProducts($cmpnyNo: Int!) {
          vendorProducts(filter: { cmpnyNo: $cmpnyNo }) {
            totalCount
            products {
              id
              name
              media
              price
              shortDescription
            }
          }
        }
      `;
      const variables = { cmpnyNo: parseInt(cmpnyNo, 10) };
      const body = { query, variables };

      const res = await axios.post(url, body);

      if (res.status === 200) {
        const filled = fillWithRepeat(res.data.products || [], 6);
        setProducts(filled);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getMenuGroup = async (cmpnyNo) => {
    console.log(cmpnyNo);
    try {
      const { data, status } = await axios.post("/erp/menuGroup/get", {
        cmpnyNo,
        menuPlatform: "ECHANGGO",
        admin: true,
      });

      if (status === 200 && Array.isArray(data)) {
        const sorted = data.sort((a, b) =>
          a.sortOrder !== b.sortOrder ? a.sortOrder - b.sortOrder : Number(b.id) - Number(a.id),
        );

        const filled = sorted.map((group) => {
          const repeated = fillWithRepeat(group.products || [], 6);
          while (repeated.length < 6) repeated.push(null);
          return { ...group, products: repeated };
        });

        setMenuGroups(filled);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModernContainer>
      <Banner cmpnyNo={cmpnyNo} isExpanded={true} />
      <Products menuGroups={menuGroups} products={products} />
      <Introduce homepageInfo={homepageInfo} url={url} />
      <Portfolio />
    </ModernContainer>
  );
};

export default ModernTheme;
